import { connect } from "react-redux";
import DataGrid, {
  Editing,
  Column,
  Pager,
  Paging,
  SearchPanel,
  Button,
} from "devextreme-react/data-grid";
import React from "react";
import PropTypes from "prop-types";
import CustomStore from "devextreme/data/custom_store";
import { loadMessages, formatMessage, locale } from "devextreme/localization";
import dictionary from "../../data/dictionary";
import { useHistory } from "react-router-dom";
import notify from "devextreme/ui/notify";
import { FILE_URL, WEBSITE_URL } from "../../utils/constants";
import { FAQVM } from "../../model/FAQ";

loadMessages(dictionary);
const pageSizes = [10, 25, 50, 100];

const FAQContainer = ({
  accessToken,
  currentLanguage,
  websiteLanguages,
  currentWebsite,
}) => {
  locale(currentLanguage.substring(0, 2));
  const history = useHistory();
  const URL = `${WEBSITE_URL}Faqs/${currentWebsite}`;

  const loadRequest = (url) => {
    return fetch(`${url}?page=1&pageSize=20`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": currentLanguage,
      },
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            return {
              data: json.data.map((data) => FAQVM(data, websiteLanguages)),
              totalCount: json.totalRows,
            };
          }
          throw json.Message;
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  };

  const deleteRequest = (url) => {
    return fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": currentLanguage,
      },
    }).then((result) => {
      if (result.ok) {
        return result.text().then((text) => {
          notify(
            {
              message: JSON.parse(text).message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
        });
      } else {
        return result.json().then((json) => {
          throw json.Message;
        });
      }
    });
  };

  const onToolbarPreparing = (e) => {
    const toolbarItems = e.toolbarOptions.items;

    toolbarItems.forEach(function (item) {
      if (item.name === "addRowButton") {
        item.options = {
          icon: "plus",
          onClick: function () {
            // Implement custom save logic here
            history.push("/faq/add");
          },
        };
      }
    });

    toolbarItems.push({
      location: "center",
      text: "Danh sách Câu hỏi thường gặp",
    });
  };

  const newsData = new CustomStore({
    key: "id",
    load: (loadOptions) => loadRequest(`${URL}`, loadOptions),
    remove: (key) => deleteRequest(`${URL}/${key}`),
  });

  const gotoDetailPage = (faqId) => {
    history.push(`/faq/${faqId}`);
  };

  const imgCellRender = (data) => {
    return (
      <img
        alt="GHM Image"
        src={`${FILE_URL}/${data.value}`}
        style={{ height: 50 }}
      />
    );
  };

  return (
    <React.Fragment>
      <DataGrid
        keyExpr="id"
        dataSource={newsData}
        allowColumnReordering={true}
        remoteOperations={true}
        selection={{ mode: "single" }}
        showBorders={true}
        onToolbarPreparing={onToolbarPreparing}
        allowColumnResizing={true}
        columnResizingMode={"widget"}
      >
        <Editing useIcons={true} allowAdding={true} allowDeleting={true} />
        <SearchPanel visible={true} highlightCaseSensitive={true} />

        {websiteLanguages.map((item, index) => (
          <Column
            key={index}
            dataField={`question-${item.languageId}`}
            dataType="string"
            caption={formatMessage("question")}
            visible={item.languageId === currentLanguage}
          />
        ))}

        {websiteLanguages.map((item, index) => (
          <Column
            key={index}
            dataField={`answer-${item.languageId}`}
            dataType="string"
            caption={formatMessage("answer")}
            visible={item.languageId === currentLanguage}
          />
        ))}

        {websiteLanguages.map((item, index) => (
          <Column
            key={index}
            dataField={`faqGroupName-${item.languageId}`}
            dataType="string"
            caption={formatMessage("faqGroup")}
            visible={item.languageId === currentLanguage}
          />
        ))}

        <Column dataField="photo" cellRender={imgCellRender} />
        <Column
          dataField="alt"
          dataType="string"
          caption={formatMessage("alt")}
        />
        <Column
          dataField="order"
          dataType="number"
          caption={formatMessage("order")}
        />
        <Column
          dataField="isActive"
          dataType="boolean"
          caption={formatMessage("isActive")}
        />

        <Column type="buttons" caption={formatMessage("actionCol")}>
          <Button name="delete" />
          <Button
            hint="Info"
            icon="info"
            onClick={(e) => gotoDetailPage(e.row.key)}
          />
        </Column>

        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
        <Paging defaultPageSize={10} />
      </DataGrid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.data.token,
    currentLanguage: state.setting.currentLanguage,
    languages: state.setting.languages,
    currentWebsite: state.website.data.currentWebsite,
    websiteLanguages: state.website.data.languages,
  };
};

FAQContainer.propTypes = {
  accessToken: PropTypes.string,
  languages: PropTypes.array,
  currentLanguage: PropTypes.string,
  websiteId: PropTypes.string,
  websiteLanguages: PropTypes.array,
  currentWebsite: PropTypes.string,
  currentWebsiteLanguage: PropTypes.string,
};

export default connect(mapStateToProps, null)(FAQContainer);
